import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    activeTab: 'admins',
    notifications: [],
    theme: 'light',
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notif => notif.id !== action.payload
      );
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { setActiveTab, addNotification, removeNotification, setTheme } = uiSlice.actions;
export default uiSlice.reducer;
